import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from 'lucide-react';
import { cn } from '@shared/lib/utils';
import { MobileBar } from './mobile-bar';

interface MobileTopBarProps {
  onMenuOpen: () => void;
  className?: string;
}

export function MobileTopBar({ onMenuOpen, className }: MobileTopBarProps): React.ReactElement {
  const { t } = useTranslation('cabinet');

  return (
    <header
      className={cn(
        'sticky top-0 z-30 bg-background pt-[var(--layout-header-padding-top-mobile,16px)]',
        className
      )}
    >
      <MobileBar
        leading={
          <button
            type="button"
            onClick={onMenuOpen}
            aria-label={t('header.openMenu')}
            className="flex size-tap shrink-0 items-center justify-center rounded-xl text-foreground transition-colors duration-fast ease-standard hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <Menu className="size-header-icon" />
          </button>
        }
      />
    </header>
  );
}
